import React from 'react';
import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';

export type ConfirmModalProps = {
  /**
   * Modal content to display
   */
  content: string;
  /**
   * Whether this component is visible
   */
  open: boolean;
  /**
   * Sets component visibility
   * @param open Whether the component is visible
   * @returns void
   */
  setOpen: (open: boolean) => void;
  /**
   * Called when the `OK` button is pressed
   * @returns void
   */
  onOk: () => void;
  /**
   * Called when the `Cancel` button is pressed
   * @returns
   */
  onCancel?: () => void;
  /**
   * Modal display label
   */
  label?: string;
  /**
   * Label for `OK` button
   */
  okLabel?: string;
  /**
   * Label for `Cancel` button
   */
  cancelLabel?: string;
};

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  content,
  open,
  setOpen,
  onOk,
  onCancel,
  label,
  okLabel = 'OK',
  cancelLabel = 'Cancel',
}) => {
  const handleConfirm = () => {
    setOpen(false);
    onOk?.();
  };

  const handleClose = () => {
    setOpen(false);
    onCancel?.();
  };

  return (
    <Dialog open={open} onClose={handleClose} aria-label={label}>
      <DialogContent>{content}</DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          {cancelLabel}
        </Button>
        <Button onClick={handleConfirm} color="primary">
          {okLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
